import { EFinancingProgram } from '@if/core/types'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface Props {
  id: string
  financingProgramId: EFinancingProgram
}
const UpdateApplicantButton = ({ id, financingProgramId }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <AsyncActionButton
      sx={{ mb: 1 }}
      fullWidth
      variant="contained"
      onClick={() => {
        navigate(`/credits/${financingProgramId}/${id}/edit?showTabIndex=0`)
      }}
    >
      {t('viewCreditApplication.updateApplicant')}
    </AsyncActionButton>
  )
}

export default UpdateApplicantButton
